"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _stores = require("@seedlang/stores");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var GrammarTreeNodeShowWrapper = function GrammarTreeNodeShowWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.loadNode(props.treeNodeId);
      if (!_state.TreeUI.userTreeNodeStore.hasIndexData) {
        _state.TreeUI.userTreeNodeStore.loadGrammarIndex({
          ids: {
            language_id: _state.AppUI.targetLanguageId
          }
        });
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.treeNodeId !== this.props.treeNodeId) {
          this.loadNode();
          _stores.ConceptWordStore.setPage(1);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.TreeUI.treeNodeStore.clearShowData();
      }
    }, {
      key: "toggleHideYoutubeVideo",
      value: function toggleHideYoutubeVideo() {
        var hideYoutubeVideo = !_state.TreeUI.user.hideYoutubeVideo;
        this.updateUser('hideYoutubeVideo', hideYoutubeVideo);
      }
    }, {
      key: "updateUser",
      value: function updateUser(field, value) {
        var data = {};
        data[field] = value;
        _state.TreeUI.user.set(field, value);
        _state.TreeUI.authUserStore.update({
          data: data
        }, noop);
      }
    }, {
      key: "loadNode",
      value: function loadNode(treeNodeId) {
        if (treeNodeId) {
          _state.TreeUI.treeNodeStore.getShow({
            queryStrings: {
              expanded: true
            },
            ids: {
              treeNodeId: treeNodeId
            }
          }, this.loadContent);
        } else if (this.props.treeNodeId) {
          _state.TreeUI.treeNodeStore.getShow({
            queryStrings: {
              expanded: true
            },
            ids: {
              treeNodeId: this.props.treeNodeId
            }
          }, this.loadContent);
        }
      }
    }, {
      key: "loadContent",
      value: function loadContent(resp) {
        _state.TreeUI.treeNodeStore.setShowData(resp);
        this.loadUserDecks(resp);
        this.loadWords(resp);
        _state.AppUI.scrollToPageTop();
      }
    }, {
      key: "topIsInView",
      value: function topIsInView(el) {
        var rect = el.getBoundingClientRect();
        return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
      }
    }, {
      key: "loadUserDecks",
      value: function loadUserDecks(resp) {
        var _resp$treeNodeGrammar;
        var concept = ((_resp$treeNodeGrammar = resp.treeNodeGrammarConcepts) === null || _resp$treeNodeGrammar === void 0 ? void 0 : _resp$treeNodeGrammar.length) > 0 ? resp.treeNodeGrammarConcepts[0].concept : null;
        if (concept) {
          _state.TreeUI.userDeckStore.getIndex({
            queryStrings: {
              grammar_concept_id: concept.id,
              user_id: _state.TreeUI.user.id
            }
          });
        }
      }
    }, {
      key: "loadWords",
      value: function loadWords(resp) {
        var _resp$treeNodeGrammar2;
        var concept = ((_resp$treeNodeGrammar2 = resp.treeNodeGrammarConcepts) === null || _resp$treeNodeGrammar2 === void 0 ? void 0 : _resp$treeNodeGrammar2.length) > 0 ? resp.treeNodeGrammarConcepts[0].concept : null;
        _stores.ConceptWordStore.getIndex({
          ids: {
            conceptId: concept === null || concept === void 0 ? void 0 : concept.id
          },
          filters: {
            root: true
          }
        });
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return !_state.TreeUI.treeNodeStore.hasShowData && (0, _utils.isBlank)(this.props.treeNode);
      }
    }, {
      key: "showVocabSpinner",
      get: function get() {
        var _this$treeNodeGrammar;
        return ((_this$treeNodeGrammar = this.treeNodeGrammarConcept) === null || _this$treeNodeGrammar === void 0 || (_this$treeNodeGrammar = _this$treeNodeGrammar.concept) === null || _this$treeNodeGrammar === void 0 ? void 0 : _this$treeNodeGrammar.rootWordsCount) > 0 && _stores.ConceptWordStore.requestCounter > 0;
      }
    }, {
      key: "treeNodeGrammarConcept",
      get: function get() {
        if ((0, _utils.isPresent)(_state.TreeUI.treeNodeStore.showData.treeNodeGrammarConcepts) && _state.TreeUI.treeNodeStore.showData.treeNodeGrammarConcepts.length >= 0) {
          return _state.TreeUI.treeNodeStore.showData.treeNodeGrammarConcepts[0];
        }
        return null;
      }
    }, {
      key: "userDecks",
      get: function get() {
        var _TreeUI$treeNodeStore;
        var deckIds = (_TreeUI$treeNodeStore = _state.TreeUI.treeNodeStore.showData) === null || _TreeUI$treeNodeStore === void 0 || (_TreeUI$treeNodeStore = _TreeUI$treeNodeStore.treeNodeDecks) === null || _TreeUI$treeNodeStore === void 0 ? void 0 : _TreeUI$treeNodeStore.map(function (item) {
          return item.deck.id;
        });
        return _state.TreeUI.userDeckStore.hasIndexData && _state.TreeUI.userDeckStore.indexData.filter(function (userDeck) {
          return deckIds === null || deckIds === void 0 ? void 0 : deckIds.includes(userDeck.deckId);
        });
      }
    }, {
      key: "tabs",
      get: function get() {
        var _TreeUI$treeNodeStore2, _this$treeNodeGrammar2, _this$treeNodeGrammar3, _this$treeNodeGrammar4;
        var tabs = [{
          name: 'grammar',
          label: 'Grammar',
          "default": true,
          hidden: !_state.TreeUI.treeNodeStore.hasShowData
        }, {
          name: 'decks',
          label: 'Decks',
          "default": false,
          hidden: !_state.TreeUI.treeNodeStore.hasShowData || ((_TreeUI$treeNodeStore2 = _state.TreeUI.treeNodeStore.showData.treeNodeDecks) === null || _TreeUI$treeNodeStore2 === void 0 ? void 0 : _TreeUI$treeNodeStore2.length) === 0
        }, {
          name: 'sentences',
          label: 'Sentences',
          hidden: (0, _utils.isBlank)((_this$treeNodeGrammar2 = this.treeNodeGrammarConcept) === null || _this$treeNodeGrammar2 === void 0 ? void 0 : _this$treeNodeGrammar2.concept) || this.treeNodeGrammarConcept.concept.sentencesCount === 0 || !this.treeNodeGrammarConcept.concept.displaySentences
        }, {
          name: 'words',
          label: 'Words',
          hidden: ((_this$treeNodeGrammar3 = this.treeNodeGrammarConcept) === null || _this$treeNodeGrammar3 === void 0 || (_this$treeNodeGrammar3 = _this$treeNodeGrammar3.concept) === null || _this$treeNodeGrammar3 === void 0 ? void 0 : _this$treeNodeGrammar3.rootWordsCount) === 0
        }, {
          name: 'comments',
          label: "".concat((_this$treeNodeGrammar4 = this.treeNodeGrammarConcept) === null || _this$treeNodeGrammar4 === void 0 || (_this$treeNodeGrammar4 = _this$treeNodeGrammar4.concept) === null || _this$treeNodeGrammar4 === void 0 ? void 0 : _this$treeNodeGrammar4.commentsCount, " Comments")
        }];
        return tabs;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showSpinner: this.showSpinner,
          showVocabSpinner: this.showVocabSpinner,
          treeNodeGrammarConcept: this.treeNodeGrammarConcept,
          treeNode: _state.TreeUI.treeNodeStore.showData,
          tabs: this.tabs,
          wordStore: _stores.ConceptWordStore,
          userDecks: this.userDecks,
          loadNode: this.loadNode,
          toggleHideYoutubeVideo: this.toggleHideYoutubeVideo
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "toggleHideYoutubeVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleHideYoutubeVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadContent", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadContent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topIsInView", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "topIsInView"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadUserDecks", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadUserDecks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVocabSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVocabSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "treeNodeGrammarConcept", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "treeNodeGrammarConcept"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userDecks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tabs"), _class2.prototype), _class2)) || _class;
};
GrammarTreeNodeShowWrapper.displayName = 'GrammarTreeNodeShowWrapper';
var _default = exports["default"] = GrammarTreeNodeShowWrapper;